import loadable from '@loadable/component';

export const SparklesColorfulIcon = loadable(() => import('./SparklesColorful'));
